import { render, staticRenderFns } from "./EmployeeRatings.vue?vue&type=template&id=cda1653c&"
import script from "./EmployeeRatings.vue?vue&type=script&lang=js&"
export * from "./EmployeeRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports